import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './routes/Login'
import Dashboard from './routes/Dashboard'
import ChannelProfiles from './routes/ChannelProfiles'
import Scripts from './routes/Scripts'
import Stories from './routes/Stories'
import Characters from './routes/Characters'
import Videos from './routes/Videos'
import Publish from './routes/Publish'
import Factory from './routes/Factory'
import Sources from './routes/Sources'
import ScriptEditor from './routes/ScriptEditor'
import ScriptExport from './routes/ScriptExport'
import Settings from './routes/Settings'
import Jobs from './routes/Jobs'
import Layout from './components/Layout'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/channel-profiles" element={<ChannelProfiles />} />
        <Route path="/scripts" element={<Scripts />} />
        <Route path="/scripts/:id" element={<ScriptEditor />} />
        {/* SD bundle B (U10/U11): script export. Not in sidebar nav — */}
        {/* the editor (SD bundle A) links here from its Export button. */}
        <Route path="/scripts/:id/export" element={<ScriptExport />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/characters" element={<Characters />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/publish" element={<Publish />} />
        <Route path="/factory" element={<Factory />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
